/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TextInputs */

const en_text = /** @type {(inputs: TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text`)
};

const fr_text = /** @type {(inputs: TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte`)
};

const de_text = /** @type {(inputs: TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text`)
};

const it_text = /** @type {(inputs: TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testo`)
};

const ru_text = /** @type {(inputs: TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текст`)
};

const es_text = /** @type {(inputs: TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto`)
};

const zh_cn2_text = /** @type {(inputs: TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文本`)
};

const ja_text = /** @type {(inputs: TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文章`)
};

const hi_text = /** @type {(inputs: TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूलपाठ`)
};

const pt_pt2_text = /** @type {(inputs: TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto`)
};

/**
* | output |
* | --- |
* | "Text" |
*
* @param {TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const text = /** @type {((inputs?: TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_text(inputs)
	if (locale === "de") return de_text(inputs)
	if (locale === "it") return it_text(inputs)
	if (locale === "ru") return ru_text(inputs)
	if (locale === "es") return es_text(inputs)
	if (locale === "zh-CN") return zh_cn2_text(inputs)
	if (locale === "ja") return ja_text(inputs)
	if (locale === "hi") return hi_text(inputs)
	if (locale === "pt-PT") return pt_pt2_text(inputs)
	return en_text(inputs)
});